var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-right mb-2 col-10 offset-1"},[_c('CButton',{attrs:{"color":"primary","to":"/partner/profile"}},[_vm._v("Back")])],1),_c('div',[(_vm.partnerInfo)?_c(_vm.partnerInfo.component,{tag:"component"}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }